import { useContext } from 'react';
import { AuthContext } from '../services/authContext';
import { AuthContextType } from '../types';
import { AUTH_ERROR_MESSAGES } from '../constants';

/**
 * Custom hook to access authentication context
 * @returns AuthContextType - Authentication state and methods
 * @throws Error if used outside of AuthProvider
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error(AUTH_ERROR_MESSAGES.CONTEXT_ERROR);
  }
  return context;
};

export default useAuth;